import { Divider, Flex, Text } from '@chakra-ui/layout';
import { Avatar, Box, HStack, Spacer, VStack } from '@chakra-ui/react';
import { djs } from '@duke-hq/djs';

import { UserAvatar } from './UserAvatar';
import { NoteInterface } from './types';
import { NoteMetadata } from './components/NoteMetadata';
import { NoteActions } from './components/NoteActions';

export function Note(props: NoteInterface) {
  const {
    id,
    category,
    outcome,
    text,
    createdBy,
    date_time,
    note_type,
    users,
    with_user_drn,
    about_user_drn,
    pinnedAt,
  } = props;
  const authorFullName = createdBy ? `${createdBy.first_name} ${createdBy?.last_name}` : '';

  const withUser = with_user_drn !== null && users ? users[with_user_drn] : null;
  const aboutUser = about_user_drn !== null && users ? users[about_user_drn] : null;

  return (
    <Box as="section" width={'400px'} px={{ base: '4', md: '2' }}>
      <Flex direction="row-reverse">
        <Box
          width={{ base: 'full', sm: 'md' }}
          borderRadius="lg"
          bg="bg.surface"
          borderWidth={pinnedAt ? 2 : 0}
          borderColor="bg.accent.inverse-muted"
        >
          <VStack spacing="2" align="left" m="4">
            <HStack justifyContent="space-between" position="relative">
              <Box mr="32px">
                <NoteMetadata
                  noteType={note_type}
                  category={category}
                  outcome={outcome}
                  pinnedAt={pinnedAt}
                />
              </Box>
              {id ? (
                <Box position="absolute" right={0} top={0}>
                  <NoteActions noteId={id} isPinned={Boolean(pinnedAt)} />
                </Box>
              ) : null}
            </HStack>
            <UserAvatar
              drn={with_user_drn}
              label="With"
              user={{
                ...withUser,
                displayName: withUser?.displayName ?? undefined,
                avatar: withUser?.avatar ?? undefined,
                role: withUser?.role ?? undefined,
              }}
            />
            {with_user_drn !== about_user_drn ? (
              <UserAvatar
                drn={about_user_drn}
                label="About"
                user={{
                  ...aboutUser,
                  displayName: aboutUser?.displayName ?? undefined,
                  avatar: aboutUser?.avatar ?? undefined,
                  role: aboutUser?.role ?? undefined,
                }}
              />
            ) : null}

            <Divider my="1" borderColor="bg.muted" />

            <Box
              w="full"
              color="fg.muted"
              lineHeight="tall"
              fontSize="sm"
              wordBreak="break-word"
              whiteSpace="pre-wrap"
            >
              {text}
            </Box>

            <Divider my="1" borderColor="bg.muted" />

            <HStack>
              {<Avatar size="xs" src={undefined} name={authorFullName} />}
              <Box>
                <Text fontWeight="medium" fontSize="xs">
                  {authorFullName}
                </Text>
              </Box>
              <Spacer />
              <Text textStyle="xs" color="fg.subtle">
                {djs(date_time).format('LLL')}
              </Text>
            </HStack>
          </VStack>
        </Box>
      </Flex>
    </Box>
  );
}
